export const PAGE_URL = '/content-hub';

export const EXPERT_PER_PAGE = 5;
export const GALLERY_PER_PAGE = 6;

export const NOT_FOUND_IMAGE = {
  src: 'https://assets.isuzu-tis.com/not_found_41c6e035ef.svg',
  alt: 'not-found',
  width: 373,
  height: 273,
} as const;
